import { type RoundStats, scoreRound } from "../../shared/score";
import { startRound, submitScore } from "../api";
import { $, getCallsign, showRoundEnd } from "../ui";
import { PipelineBuilder } from "./builder";
import { Game } from "./game";

export interface Screen {
  show(): void;
}

export function createAirScreen(): Screen {
  const hudName = $("#hud-name");
  const hudScore = $("#hud-score");
  const hudTime = $("#hud-time");
  const phaseTitle = $("#phase-title");
  const phaseHint = $("#phase-hint");
  const startBtn = $<HTMLButtonElement>("#start");
  let roundId: string | null = null;

  const builder = new PipelineBuilder($("#builder"));
  const game = new Game($<HTMLCanvasElement>("#sky"), () => builder.get(), {
    onPipelineEvent: (node, passed, reason) => builder.flash(node, passed, reason),
    onHud: ({ remaining, score }) => {
      hudScore.textContent = String(score);
      hudTime.textContent = `${Math.ceil(remaining)}s`;
    },
    onPhase: (phase) => {
      phaseTitle.textContent = phase.title;
      phaseHint.textContent = phase.hint;
      phaseTitle.parentElement?.classList.remove("phase-new");
      void phaseTitle.offsetWidth;
      phaseTitle.parentElement?.classList.add("phase-new");
    },
    onRoundEnd: (stats) => void finish(stats),
  });

  const reset = () => {
    startBtn.disabled = false;
    startBtn.textContent = "Start round";
    hudScore.textContent = "0";
    hudTime.textContent = "90s";
    game.practice();
  };

  startBtn.addEventListener("click", async () => {
    const name = getCallsign();
    if (!name || game.running) return;
    startBtn.disabled = true;
    roundId = null;
    try {
      roundId = (await startRound(name, "air")).roundId;
    } catch (err) {
      phaseHint.textContent = `Offline round: your score won't reach the leaderboard (${(err as Error).message}).`;
    }
    game.startRound();
    startBtn.textContent = "Round in progress";
  });

  function finish(stats: RoundStats): Promise<void> {
    const score = scoreRound(stats);
    const id = roundId;
    return showRoundEnd({
      title: "Round over",
      score,
      rows: [
        ["Hostiles downed", stats.downed],
        ["…of which jets", stats.jetsDowned],
        ["Friendlies hit", stats.friendliesHit],
        ["Shells fired", stats.shellsFired],
        ["Hostiles escaped", stats.escaped],
      ],
      submit: id ? () => submitScore(id, score, stats) : null,
      onClose: reset,
    });
  }

  return {
    show() {
      hudName.textContent = getCallsign() ?? "";
      if (!game.running) reset();
    },
  };
}
